import datasets from './dataset'
import {toCurrencyNumber, toThousands} from "../utils";
export function moneyFormatter(row, column, cellValue, index){
  if(cellValue!=null){
    return toThousands(cellValue);
  }else{return null}
}
export function numberFormatter(row, column, cellValue, index){
  if(cellValue!=null){
    return toCurrencyNumber(cellValue);
  }else{return null}
}
export function formatMoney(cellValue){
  if(cellValue!=null){
    return toThousands(cellValue);
  }else{return null}
}
export function defaultFormatter(){
  return function(row, column, cellValue, index){
    return cellValue
  }
}
/**
 * 使用指定的数据格式化
 * @param options
 * @param value
 * @returns {*}
 */
export function formatWithMappings(options, value){
  if(options!=null && value !=null){

    if((typeof value)=='string'){
      let vals=[];
      value.split(",").forEach(e=>{
        let opt=options.find(item => item.value == e);
        if(opt){
          vals.push(opt.label);
        }else{
          console.warn("option not found. value:["+value+"] ")
        }
      })
      return vals.join(",")
    }else{
      let opt=options.find(item => item.value == value);
      if(opt){
        return opt.label;
      }else{
        console.warn("option not found. value:["+value+"] ")
      }
    }
  }
  return value;
}
/**
 * 格式化一个数值
 * @param dataset 数据集名称，参考 commons-mapping.json
 * @param value 待转换的值
 * @returns 转换后的值
 */
export function formatWithDataSet(dataset,value) {
  let mpData = datasets[dataset];
  if(mpData==null){
    console.error(`dataset[${dataset}] not exists`)
    return value
  }
  return formatWithMappings(mpData,value);
}
/**
 * 映射数据格式化。
 * @param mappingData
 * @returns {Function}
 */
export function mappingDataFormatter(mappingData){
  if(mappingData==null){
    console.error(`mappingData can not be null`)
    return defaultFormatter()
  }
  let cacheMappingData=mappingData;
  return function(row, column, cellValue, index){
    return formatWithMappings(cacheMappingData,cellValue);
  }
}
/**
 * 创建一个适用于el-datasetFormatter
 * @param dataset 数据集名称，参考 commons-mapping.json
 * @returns 适用于el-datasetFormatter
 */
export function datasetFormatter(dataset) {
  let mpData = datasets[dataset];
  if(mpData==null){
    console.error(`dataset[${dataset}] not exists`)
    return defaultFormatter()
  }
  return mappingDataFormatter(mpData);
}



/**
 * 映射数据格式化。
 * @param mappingData
 * @returns {Function}
 */
export function suffixFormatter(suffix){
  return function(row, column, cellValue, index){
    if(cellValue){
     return suffix!=null ? cellValue+suffix:cellValue;
    }else{
      return ""
    }
  }
}
/**
 * 映射数据格式化。
 * @param mappingData
 * @returns {Function}
 */
import {areaMapping} from "@/components/base/area/area-tree"


export function areaFormatter(row, column, cellValue, index){
  let node = areaMapping[cellValue];
  if(node){
    let addr=[];
    while(node!=null){
      addr.unshift(node.name)
      node=node.parent;
    }
    return addr.join("-");
  }else{
    return cellValue;
  }
}
/**
 * 使用指定的数据格式化
 * @param options
 * @param value
 * @returns {*}
 */
export function formatArea(val){
  if(val!=null){
    let obj = areaMapping[val];
    if(obj!=null){
      return obj.name;
    }
  }
  return "";
}
export function formatAreaByDistric(val){
  if(val!=null){
    let str=[];
    let obj = areaMapping[val];
    while(true){
      if(obj!=null){
        str.push(obj.name)
        obj=obj.parent;
      }else{
        break;
      }
    }
    return str.reverse().join("-");
  }
  return val;
}
export function summaryFormatter(maxLen){
  return function(row, column, cellValue, index){
    if(cellValue && cellValue.length>maxLen){
      return cellValue.substring(0,maxLen)+"...";
    }
    return cellValue
  }
}
export function label2CodeWithDataSet(dataset,label) {
  let options = datasets[dataset];
  if(options==null){
    throw `dataset[${dataset}] not exists`;
  }
  if(options!=null && label !=null){
    let opt=options.find(item => item.label == label);
    if(opt){
      return opt.value;
    }else{
      console.warn("option not found. label:["+label+"] options:",options)
    }
  }
  return label;
}
